import { createFileRoute, redirect } from '@tanstack/react-router';
import { selectLoop } from './-selectLoop';

export const Route = createFileRoute('/(app)/org/$org/')({
  beforeLoad: async ({ context: { queryClient, organizationId }, params: { org } }) => {
    const loop = await selectLoop(queryClient, organizationId ?? '');
    if (!loop) return;
    throw redirect({
      to: '/org/$org/loop/$loopId',
      params: { org, loopId: loop.id },
      replace: true,
    });
  },
});
